module.exports = {
      id: "arrow-down-usage",
      viewBox: "0 0 22.422 26.468",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#arrow-down",
      toString: function () {
        return this.url;
      }
    }